import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class ProjectsHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            projects:this.props.projects, 
            content:this.props.content, 
            
        }
        

    }
     
    componentDidMount()
    {  
        if(this.props.projects && this.state.loading === 1)
        {
             this.setState({loading:0});     
        }

        const script = document.createElement("script");
        script.src   = base_url+"assets/js/loadSlider.js";  
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
        if (window.loadSlider && this.props.projects.length > 0) {
        window.home_carousel_1();
        this.setState({loading:0})
        }
        };
         
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

        <div className="projects-home services-area carousel-shadow flex-less inc-thumb default-padding ba" >
        <div className="container">
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <div className="site-heading text-center">
                        <h4>Projects</h4>
                        <h2>Our Major Projects</h2>    
                       
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="services-items services-carousel-3-col owl-carousel owl-theme text-center inc-overlay">
                       
                    {this.state.projects.map((item, index) => (
                        <div className="item">
                            <div className="thumbs overlay">
                                <img src={item.image} alt={item.title} />
                                <div className="info">
                                  <h4>{item.title}</h4>
                                  <p>
                                  <div dangerouslySetInnerHTML={{ __html: item.short_info }} /> 

                                  </p>
                                  <Link to={base_url+`project-info/${item.slug}`}>Read More</Link >
                                </div>
                            </div>
                            <div className="info">
                                <div className="content">
                                    <div className="top-info">
                                        <h4><Link to={base_url+`project-info/${item.slug}`}>{item.title}</Link></h4>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    ))}
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
       
    );
}

}

export default ProjectsHome;